import PrintMaterialsCommunities from "./PrintMaterialsCommunities";

export default PrintMaterialsCommunities;
